import type { HereAndNowTab } from "@lib/logic";

import { Explore } from "./explore/Explore";
import { Rooms } from "./rooms/Rooms";
import { HaN } from "./shell/HaN";
import { Workspaces } from "./workspaces/Workspaces";

export const HereAndNowRevamp = ({ tab }: { tab: HereAndNowTab }) => {
  return (
    <HaN.Page tab={tab}>
      <HaN.Header />
      <HaN.CalendarSyncTile />

      <HaN.TabsBar>
        <HaN.Tabs />
      </HaN.TabsBar>

      <HaN.FilterBar>
        <Rooms.Filters />
        <Workspaces.Filters />
      </HaN.FilterBar>

      <HaN.List>
        <Rooms.List />
      </HaN.List>

      <HaN.MapStage>
        <Rooms.Map />
        <Workspaces.Map />
        <Explore.Map />
        <HaN.FloorSelector />
      </HaN.MapStage>
    </HaN.Page>
  );
};
